import React, {Fragment} from 'react';
import {Avatar, Space} from "antd";
import {useAuth0} from "@auth0/auth0-react";


/**
 * The profile picture with the profile context menu.
 */
const ProfileContextMenu = () => {
    const { user } = useAuth0();
    const {nickname} = user;
    const {picture} = user;

    return (
        <Fragment>
            <Space>
                {picture ? (<Avatar src={picture}/>) : (<i className="far fa-user"/>)}
                {nickname}
            </Space>
        </Fragment>
    );
};

export default ProfileContextMenu;